import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Profile: React.FC = () => {
  const { currentUser, updateUserProfile, logout } = useAuth();
  const [displayName, setDisplayName] = useState(currentUser?.displayName || '');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setError('');
      setMessage('');
      setLoading(true);
      await updateUserProfile(displayName);
      setMessage('Name saved.');
    } catch (err: any) {
      setError(err.message || 'Could not update your profile.');
      console.error('Profile update error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (err: any) {
      setError(err.message || 'Could not log out.');
      console.error('Logout error:', err);
    }
  };

  return (
    <div className="ss-sheet ss-auth">
      <p className="ss-kicker">Account</p>
      <h1 className="ss-title">Your profile</h1>
      <p className="ss-sub">This name is what friends see in the lobby and on the scoreboard.</p>

      {error && (
        <div className="ss-error" role="alert">
          {error}
        </div>
      )}

      {message && (
        <div className="alert alert-success" role="status">
          {message}
        </div>
      )}

      <p className="ss-label">Email</p>
      <p className="ss-who" style={{ marginBottom: '1rem' }}>
        {currentUser?.email}
      </p>

      <form onSubmit={handleSubmit}>
        <label htmlFor="displayName" className="ss-label">
          Display name
        </label>
        <input
          type="text"
          id="displayName"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          className="ss-input"
          required
          autoComplete="nickname"
          placeholder="Pat"
        />

        <button type="submit" disabled={loading} className="ss-btn ss-btn-primary" style={{ width: '100%' }}>
          {loading ? 'Saving' : 'Save name'}
        </button>
      </form>

      <div className="ss-row" style={{ marginTop: '0.85rem' }}>
        <Link to="/" className="ss-btn ss-btn-ghost">
          Back home
        </Link>
        <button type="button" onClick={handleLogout} className="ss-btn ss-btn-danger">
          Log out
        </button>
      </div>
    </div>
  );
};

export default Profile;
